/**
 * Array of valid keys in a block type settings deprecation object.
 *
 * @type {string[]}
 */
export var DEPRECATED_ENTRY_KEYS = ['attributes', 'supports', 'save', 'migrate', 'isEligible'];
//# sourceMappingURL=constants.js.map